import { PaginatedResponse } from './paginated-response';

export class Organization {
  'Organization ID'?: string;
  Name: string;
  Description: string;

  constructor(data: any = {}) {
    this['Organization ID'] = data['Organization ID'] || '';
    this.Name = data.Name || '';
    this.Description = data.Description || '';
  }
}

export class PaginatedOrganizationDTO extends PaginatedResponse {
  records: Organization[];
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/organization.ts